<template>
  <div class="ccui-home-index" v-if="isShow">
    <div class="emc-container">
      <div style="width: 100%">
        <div class="emc-top row">
          <div class="emc-title">批量下单</div>
          <div class="flex">
            <UnitSelect
              v-if="unitSelectData.length > 0"
              :purchaseUndertakeOrgIdTreeData="unitSelectData"
              :purchaseOrgId="purchaseOrgId"
              :purchaseUndertakeOrgIdValue="purchaseUndertakeOrgIdValue"
            />
            <div class="emc-select-address">
              <label>配送至：</label>
              <el-area-selector
                style="width: 330px"
                :defaultArea="defaultAreaFix"
                :place="leftPlace"
                @getAddressOf="getAddressOf"
                :url="getAddressUrl"
                :headers="{ Authorization: this.access_token || '' }"
                :agentId="paramsData"
              ></el-area-selector>
            </div>
          </div>
        </div>
        <div class="orderHelp">
          <div class="orderHelp_step" @click="exportFun">
            <img
              style="height: 48px;width: 48px;"
              src="./images/download.png"
              alt=""
            />
            <span style="margin-top: 10px;font-size: 14px;">
              1.点击下载模板</span
            >
          </div>
          <div style="display: flex; align-items: center;margin: 0 10px 0 20px">
            <div class="dottedLine"></div>
            <i class="icon-ccui-next"></i>
          </div>
          <el-upload
            class="upload-demo"
            :accept="acceptFile('excel')"
            :action="uploadUrl"
            :headers="{ Authorization: this.access_token || '' }"
            :data="{
              agentId: 100108,
              orgId: purchaseOrgId,
              reqBo: JSON.stringify({
                provinceCode: defaultArea[0] ? defaultArea[0].code : '',
                cityCode: defaultArea[1] ? defaultArea[1].code : '',
                countyCode: defaultArea[2] ? defaultArea[2].code : '',
                streetCode: defaultArea[3] ? defaultArea[3].code : '0'
              })
            }"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-progress="handleProgress"
            :before-upload="beforeAvatarUpload"
            multiple
            :file-list="fileList"
          >
            <div class="orderHelp_step">
              <img
                style="height: 48px;width: 48px;"
                src="./images/upLoad.png"
                alt=""
              />
              <span style="margin-top: 10px;font-size: 14px;">
                2.上传清单
              </span>
            </div>
          </el-upload>
        </div>
        <div class="promptHelp">
          <div
            style="display: flex;
            margin-left:45px;
            color: red;
            justify-content: center;"
          >
            注意：
            <div>
              <p>
                1.支持直接填写商品编码和excel模板批量导入两种方式。
              </p>
              <p style="margin-top: 3px">
                2.建议按模板填写后上传，上传数量建议不超过300行，超过部分会被忽略。
              </p>
              <p style="margin-top: 3px">
                3.上传文件需为excel格式文件，且大小不超过10MB。
              </p>
              <p style="margin-top: 3px">
                4.部分商品为定制/特殊规格，不支持7天无理由退货，请下单前查看并确认商品详情页售后规则。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="solidLine"></div>
      <div class="goods-list-commodity">
        <el-table
          max-height="999999"
          ref="goodsTable"
          :data="tableData"
          @selection-change="handleSelectionChange"
          :row-style="isRed"
          border
        >
          <el-table-column
            type="selection"
            width="45"
            :selectable="selectable"
          ></el-table-column>
          <el-table-column prop="goodsNum" label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="goodsCoding" label="商品编码" width="120">
            <template slot-scope="scope">
              <el-input
                class="goodsCoding"
                placeholder="请输入"
                maxlength="8"
                v-model="scope.row.input"
                @input="inputCoding(scope.row, scope.$index)"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column
            class-name="goods-list-commodity-table-header"
            min-width="300"
          >
            <template slot="header">
              <span style="float:left">商品名称</span>
            </template>
            <template slot-scope="scope">
              <div class="clearfix">
                <!--<div class="goods-list-commodity-table-body-left">-->
                <!--{{scope.row.index}}-->
                <!--</div>-->
                <div class="goods-image" v-if="scope.row.picUrl">
                  <el-image
                    class="goods-list-commodity-table-body-center"
                    :src="scope.row.picUrl"
                    fit="scale-down"
                  >
                    <span slot="error" class="error-img">暂无图片</span>
                  </el-image>
                </div>

                <div class="goods-list-commodity-table-body-right">
                  <div
                    class="goods-list-commodity-table-body-right-item goods-list-commodity-table-body-right-item-title"
                    :title="scope.row.name"
                  >
                    {{ scope.row.name }}
                  </div>

                  <div
                    class="goods-list-commodity-table-body-right-item"
                    v-if="scope.row.extSkuId"
                  >
                    <span>商家编码：{{ scope.row.extSkuId }}</span>
                  </div>
                  <div>
                    <Tag
                      :shopType="scope.row.shopType"
                      :contractType="scope.row.contractType"
                    />
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="skuStatus" label="商品状态">
            <template slot-scope="scope">
              <p
                :class="scope.row.skuStatus == 1 ? 'available' : 'notAvailable'"
              >
                {{ scope.row.skuStatus | toSkuStatusStr }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="beforeSalePrice"
            label="销售价"
            align="right"
            header-align="left"
          >
            <template slot-scope="scope">
              <div class="tab-text tar" v-if="scope.row.salePrice">
                <p class="up-price">
                  ￥{{ Number(scope.row.salePrice).toFixed(2) }}
                </p>
                <p
                  class="goods-price-select"
                  v-if="scope.row.ladderPrice && scope.row.flag != 2"
                >
                  <span class="set-price"
                    ><div class="goods-price-select-title">
                      阶梯价<i class="icon-ccui-down"></i>
                    </div>
                    <div class="goods-price-select-box">
                      <ul>
                        <li>
                          <table>
                            <tbody>
                              <tr
                                v-for="(itemLadder, indexLaddeer) of scope.row
                                  .ladderPriceBOS"
                                :key="indexLaddeer"
                                :class="[
                                  Number(scope.row.num) >=
                                    Number(itemLadder.downString) &&
                                  Number(scope.row.num) <=
                                    Number(itemLadder.upString || 100000)
                                    ? 'active'
                                    : ''
                                ]"
                              >
                                <td
                                  v-if="itemLadder.upString"
                                  style="text-align: right"
                                >
                                  {{ itemLadder.downString }}-{{
                                    itemLadder.upString
                                  }}{{ scope.row.unitName }}：
                                </td>
                                <td v-else style="text-align: right">
                                  ≥{{ itemLadder.downString
                                  }}{{ scope.row.unitName }}：
                                </td>
                                <td>
                                  ¥{{ itemLadder.salePrice | toMoneyFormat }}
                                </td>
                              </tr>
                              <tr></tr>
                            </tbody>
                          </table>
                        </li>
                      </ul>
                    </div>
                  </span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="number" label="数量" width="130">
            <template slot-scope="scope">
              <div
                v-if="scope.row.num"
                style="display: grid; justify-items: center;"
              >
                <el-input-number
                  style="width: 100px"
                  :disabled="[2, 3, 0, 4, 6, 10].includes(scope.row.skuStatus)"
                  type="number"
                  :min="
                    scope.row.num < scope.row.minPurchaseNum
                      ? scope.row.num
                      : scope.row.minPurchaseNum
                  "
                  v-model="scope.row.num"
                  :precision="2"
                  @change="
                    value => {
                      changeTotal(value, scope.row, scope.$index);
                    }
                  "
                  :max="99999"
                  label="提交数量"
                ></el-input-number>
                <span
                  v-if="
                    scope.row.minPurchaseNum && scope.row.minPurchaseNum > 1
                  "
                  style="font-size: 12px"
                  >起订量：{{ scope.row.minPurchaseNum }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="beforeSalePrice"
            header-align="left"
            align="right"
            width="120"
            label="小计"
          >
            <template slot-scope="scope">
              <div class="tab-text tar" v-if="scope.row.total">
                <p class="up-price">
                  ￥{{ Number(scope.row.total).toFixed(2) }}
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div>
                <div class="td-button">
                  <el-button
                    plain
                    type="single-number"
                    @click="toDelete(scope.row)"
                    >删除</el-button
                  >
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="addGoods" v-if="tableData.length < 300">
        <span class="clickAdd" @click="addGoods">+新增商品</span>
      </div>
      <div id="emc-all-total" ref="total">
        <!--:style="{ display: emcTotalFix ? 'block' : 'none' }"-->
        <div class="emc-all-total">
          <div class="emc-all-total-l clearfix">
            <label>
              <el-checkbox
                class="emc-checkbox"
                style="padding-right: 19px"
                v-model="changeAll"
                ref="changeAll1"
                @change="checkAll(tableData)"
              ></el-checkbox>
              全选
            </label>
            <span class="disabledFixCheckbox"></span>
            <a href="javascript:;" @click="deletedEmcGoods()">删除选中商品</a>
          </div>
          <div class="emc-all-total-r clearfix">
            <div class="emc-all-total-r-slected-title">
              <span class="emc-all-total-r-slected-title-h2"
                >总计（不含运费）</span
              ><span class="emc-all-total-r-slected-title-p"
                >￥{{ Number(goodsTotal).toFixed(2) }}
              </span>
            </div>
            <a
              href="javascript:;"
              class="emc-all-submit-order addCart"
              @click="addCart"
              >加入购物车</a
            >
            <a
              href="javascript:;"
              class="emc-all-submit-order"
              @click="submitOrder"
              >立即下单</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="emc-all-total-fix" v-show="emcTotalFixDefault" ref="total">
      <!--:style="{ display: emcTotalFix ? 'block' : 'none' }"-->
      <div class="emc-all-total">
        <div class="emc-all-total-l clearfix">
          <label>
            <el-checkbox
              class="emc-checkbox"
              style="padding-right: 19px"
              v-model="changeAll"
              ref="changeAll"
              @change="checkAll(tableData)"
            ></el-checkbox>
            全选
          </label>
          <span class="disabledFixCheckbox"></span>
          <a href="javascript:;" @click="deletedEmcGoods()">删除选中商品</a>
        </div>
        <div class="emc-all-total-r clearfix">
          <div class="emc-all-total-r-slected-title">
            <span class="emc-all-total-r-slected-title-h2"
              >总计（不含运费）</span
            ><span class="emc-all-total-r-slected-title-p"
              >￥{{ Number(goodsTotal).toFixed(2) }}
            </span>
          </div>
          <a
            href="javascript:;"
            class="emc-all-submit-order addCart"
            @click="addCart"
            >加入购物车</a
          >
          <a
            href="javascript:;"
            class="emc-all-submit-order"
            @click="submitOrder"
            >立即下单</a
          >
        </div>
      </div>
    </div>
    <!-- 商品变动弹窗 -->
    <clear-goods ref="clearGoods" @clear="handleClear" />
    <!-- 商品是否冻结弹窗 -->
    <frozenGoods ref="frozenGoods" />
  </div>
  <div class="ccui-home-index" v-else>
    <div class="emc-container">
      <NoContent v-if="flagIsNoContent" />
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import Tag from "../dashboard/components/tag/index.vue";
import clearGoods from "@/components/clear-goods.vue";
import frozenGoods from "@/components/frozenGoods.vue";
import UnitSelect from "../dashboard/components/unitSelect/index.vue";
import {
  importBatchFile,
  qryDefault,
  batchSubAddCart,
  qryUnitOrgTree,
  addSku,
  switchAddress,
  addSkusByEmma
} from "@/api/emc-api";
// import { Emccompute } from "@/utils/emc-compute";
import { addUrlPerFix } from "@/utils";
const VUE_APP_EMI_URL = addUrlPerFix(process.env.VUE_APP_EMI_URL);
import { payRecordTemplate } from "./api/placeOrder";
import XLSX from "xlsx";
import { Loading } from "ccui";
// import store from "@/store";
const placeAnOrderUrl = addUrlPerFix(process.env.VUE_APP_PLACE_AN_ORDER_URL);
export default {
  name: "placeOrder",
  data() {
    return {
      skuIds: [],
      nums: [],
      leftPlace: "right",
      goodsDetailUrl: VUE_APP_EMI_URL,
      defaultArea: [],
      multipartFile: {},
      fileList: [],
      changeAll: false,
      emcTotalFixDefault: true,
      clientHeight: 0,
      emcTotalOffTop: 0,
      goodsTotal: 0,
      tableData: [{}, {}, {}, {}, {}],
      unitSelectData: [],
      isShow: false,
      purchaseOrgId: "",
      purchaseUndertakeOrgIdValue: "",
      isAddressOne: true,
      defaultAreaFix: [
        { code: 1, name: "北京市" },
        { code: 2801, name: "西城区" },
        { code: 54769, name: "德胜街道" }
      ],
      getAddressUrl:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/emc/cart/qryAddressOfFourth",
      access_token: Cookies.get("access_token"),
      paramsData: "100108",
      selectedItems: [],
      backCartCartNum: 2,
      isFlag: true,
      loadingObj: null
    };
  },
  components: {
    UnitSelect,
    clearGoods,
    frozenGoods,
    Tag
  },
  activated() {},
  mounted() {
    document.title = "批量下单 - 中交云采";
    window.addEventListener("scroll", this.handleScrollx, true);
    if (sessionStorage.getItem("userInfo")) {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      const token = userInfo.userToken;
      if (!token) {
        this.$store.commit("SET_IS_SHOW_DIALOG", true);
      }
    }

    if (Number(this.backCartCartNum) === 1) {
      if (Cookies.get("formCartSelect")) {
        let formCartSelectData = JSON.parse(Cookies.get("formCartSelect"));
        Cookies.set("backCartCartData", JSON.stringify(formCartSelectData), {
          path: "/",
          domain: "iccec.cn"
        });
      }
    }

    if (!Cookies.get("backCartCartData")) {
      Cookies.set("backCartCartNum", 2, {
        path: "/",
        domain: "iccec.cn"
      });
    }
    this.backCartCartNum = Number(Cookies.get("backCartCartNum"));
    if (Number(this.backCartCartNum) !== 1) {
      Cookies.remove("backCartCartData", {
        path: "/",
        domain: "iccec.cn"
      });
    } else {
      if (Cookies.get("formCartSelect")) {
        let formCartSelectData = JSON.parse(Cookies.get("formCartSelect"));
        Cookies.set("backCartCartData", JSON.stringify(formCartSelectData), {
          path: "/",
          domain: "iccec.cn"
        });
      }
    }

    this.getInfoTree();
  },
  computed: {
    uploadUrl: function() {
      return addUrlPerFix("emc.iccec.cn/apis/emc/batch/importBatchFile");
    }
  },
  watch: {
    selectedItems: {
      deep: true, //深度监听
      immediate: true,
      handler: function(newVal, oldVal) {
        this.goodsTotal = 0;
        newVal.forEach(i => {
          this.goodsTotal += i.total;
        });
        if (newVal.length == 0) {
          this.changeAll = false;
        }
      }
    }
  },
  methods: {
    handleClear(skuIds) {
      this.tableData = this.tableData.filter(
        element => !skuIds.includes(+element.input)
      );
    },
    inquiry() {
      this.skuIds = this.$route.query.skuIds.split(",");
      this.nums = this.$route.query.nums.split(",");
      let {
        provinceCode,
        cityCode,
        countyCode,
        streetCode
      } = this.$route.query;
      let addSkuNums = [];
      streetCode = streetCode ? streetCode : 0;
      for (let i = 0; i < this.skuIds.length; i++) {
        addSkuNums.push({
          skuId: Number(this.skuIds[i]),
          num: Number(this.nums[i])
        });
      }
      addSkusByEmma({
        provinceCode,
        cityCode,
        countyCode,
        streetCode,
        addSkuNums,
        selectOrg: this.purchaseOrgId,
        isShowLoading: true
      }).then(res => {
        if (res.data.data.length) {
          this.tableData = res.data.data.map(v => {
            if (v.flag == 2) {
              v.ladderPrice = false;
              v.ladderPriceBOS = [];
            }
            return v;
          });
          this.$refs.goodsTable.toggleAllSelection();
          this.tableData.forEach(i => {
            i.input = i.code;
          });
        } else {
          this.$message.closeAll();
          this.$message({
            message: res.message,
            type: "error",
            showClose: true,
            ccuiCustom: true
          });
        }
      });
    },
    async GetQryDefault() {
      console.log("走了这里");
      try {
        // 请求默认地址
        await qryDefault({
          // isShowPageLoading: true
        })
          .then(res => {
            if (res.data.code === "0") {
              if (Cookies.get("IPCodeList")) {
                this.defaultAreaFix = JSON.parse(Cookies.get("IPCodeList"));
              } else {
                this.defaultAreaFix = res.data.data;
              }
              this.defaultArea = Object.assign(this.defaultAreaFix);
            }
          })
          .catch(e => {
            this.defaultArea = JSON.parse(JSON.stringify(this.defaultAreaFix));
          });
        this.isShow = true;
        await this.getQuerList();
      } catch (err) {
        console.log(err);
      }
    },
    getQuerList() {
      let adds = [];
      this.tableData.forEach(i => {
        console.log(Object.keys(i).length, "iiii");
        if (i.code) {
          adds.push({
            skuId: i.code,
            num: i.num
          });
        }
      });
      let obj = {
        provinceCode: this.defaultArea[0] ? this.defaultArea[0].code : "",
        cityCode: this.defaultArea[1] ? this.defaultArea[1].code : "",
        countyCode: this.defaultArea[2] ? this.defaultArea[2].code : "",
        streetCode: this.defaultArea[3] ? this.defaultArea[3].code : "0",
        selectOrg: this.purchaseOrgId,
        adds
      };
      if (adds.length) {
        switchAddress(obj).then(res => {
          if (res.data.data.list) {
            let list = res.data.data.list[0].list;
            if (list) {
              // this.tableData = res.data.data.list[0].list;
              this.tableData.forEach(i => {
                if (Object.keys(i).length != 0) {
                  i.input = i.code;
                }
              });
              for (let y = 0; y < this.tableData.length; y++) {
                for (let i = 0; i < list.length; i++) {
                  if (this.tableData[y].code == list[i].code) {
                    this.tableData[y].salePrice = list[i].salePrice;
                    this.tableData[y].total = list[i].total;
                    this.tableData[y].flag = list[i].flag;
                    this.tableData[y].skuStatus = list[i].skuStatus;
                    this.tableData[y].ladderPrice =
                      list[i].flag == 2 ? false : list[i].ladderPrice;
                    this.tableData[y].ladderPriceBOS =
                      list[i].flag == 2 ? [] : list[i].ladderPriceBOS;
                    console.log(666);
                    let arr = [2, 3, 0, 4, 6, 10];
                    if (
                      !arr.includes(this.tableData[y].skuStatus) &&
                      this.tableData[y].num >= this.tableData[y].minPurchaseNum
                    ) {
                      console.log(1);
                      this.$refs.goodsTable.toggleRowSelection(
                        this.tableData[y],
                        true
                      );
                    } else {
                      console.log(2);
                      this.$refs.goodsTable.toggleRowSelection(
                        this.tableData[y],
                        false
                      );
                    }
                    break;
                  }
                }
              }

              console.log(res, "obj");
            }
          }
        });
      }
    },
    uploadBtn(uploadData) {
      console.log(uploadData, "uploadDatauploadData");
      const rABS = true;
      const f = uploadData.file;
      const reader = new FileReader();
      let jsonArr = [];
      reader.onload = e => {
        let data = e.target.result;
        if (!rABS) data = new Uint8Array(data);
        const workbook = XLSX.read(data, {
          type: rABS ? "binary" : "array"
        });
        const first_worksheet = workbook.Sheets[workbook.SheetNames[0]]; // 拿第一个sheet的内容
        jsonArr = XLSX.utils.sheet_to_json(first_worksheet, { header: 1 }); // 转成array
        const uploadFileContentList = jsonArr.filter(item => {
          if (item.length > 0) {
            return item;
          }
        });
        // 读取到文件名称、内容行数，提示用户
        this.$confirm(
          `将上传【${uploadData.file.name}】,共${uploadFileContentList.length}行, 是否继续?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.uploadRequest(uploadData); // 调接口
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      };
      if (rABS) reader.readAsBinaryString(f);
      else reader.readAsArrayBuffer(f);
    },
    uploadRequest(uploadData) {
      importBatchFile({ uploadData }).then(res => {
        console.log(res, "res");
      });
    },
    exportFun() {
      // window.location.href = this.interPostUrl2 + "/apis/emma/sc/download";
      payRecordTemplate({ agentId: 100108 }).then(res => {
        let blob = new Blob([res.data], {
          type:
            "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob);
        } else {
          let elink = document.createElement("a");
          if (
            res.headers["content-disposition"] &&
            res.headers["content-disposition"].split(";").length > 1 &&
            res.headers["content-disposition"].split(";")[1].split("filename*=")
              .length > 1
          ) {
            let filename = res.headers["content-disposition"]
              .split(";")[1]
              .split("filename*=")[1];
            filename = window.decodeURIComponent(filename);
            filename = filename.split("utf-8''")[1];
            elink.download = filename;
          }
          elink.style.display = "none";
          elink.download = "批量下单_导入模板";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        }
      });
      // console.log(this.interPostUrl2 + "/apis/sca/sc/download");
    },
    selectable(row) {
      let arr = [2, 3, 0, 4, 6, 10];
      // return true;
      if (
        !arr.includes(row.skuStatus) &&
        Object.keys(row).length != 0 &&
        row.code &&
        row.num >= row.minPurchaseNum
      ) {
        return true;
      }
      // if (row.num < row.minPurchaseNum) {
      //   return false;
      // }

      // if (row.extSkuId) return true;
    },
    // openFullScreen(type) {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: "上传中,请稍候",
    //     spinner: "el-icon-loading",
    //     background: "transparent",
    //     customClass: "uploading"
    //   });
    //   document.getElementsByClassName(
    //     "el-loading-spinner"
    //   )[0].style.backgroundColor = "rgba(51,51,51,.56)";
    //   if (type == 2) {
    //     loading.close();
    //   }
    // },
    beforeAvatarUpload(file) {
      // this.fileList = [];
      // const isLt10M = file.size / 1024 / 1024 < 10;
      // if (!isLt10M) {
      //   this.$message.closeAll();
      //   this.$message({
      //     showClose: true,
      //     message: `文件大小不能超过10MB`,
      //     type: "error",
      //     ccuiCustom: true
      //   });
      //   return false;
      // }
    },
    inputCoding(item, index) {
      if (item.input.length == 8 && !isNaN(item.input)) {
        let obj = {
          provinceCode: this.defaultArea[0] ? this.defaultArea[0].code : "",
          cityCode: this.defaultArea[1] ? this.defaultArea[1].code : "",
          countyCode: this.defaultArea[2] ? this.defaultArea[2].code : "",
          streetCode: this.defaultArea[3] ? this.defaultArea[3].code : "0",
          addSkuId: Number(item.input),
          selectOrg: this.purchaseOrgId,
          addNum: item.num ? item.num : 1
        };
        addSku(obj).then(res => {
          // console.log(res.data.data, "  this.tableData");
          if (res.data.data.code != "" && res.data.data.code != "1") {
            let a = this.tableData.findIndex(i => i.code == res.data.data.code);
            if (a != -1) {
              this.$message.closeAll();
              this.$message({
                message: `已添加过该商品${this.tableData[a].code},商品数量+1`,
                type: "warning",
                showClose: true,
                ccuiCustom: true
              });
              this.tableData[a].num += 1;
              this.tableData[a].total =
                this.tableData[a].num * this.tableData[a].salePrice;
              // this.tableData.splice(index, 1);
            } else {
              this.$set(this.tableData, index, res.data.data);
              this.$set(this.tableData[index], "input", res.data.data.code);
              if (res.data.data.flag == 2) {
                this.$set(this.tableData[index], "ladderPrice", false);
                this.$set(this.tableData[index], "ladderPriceBOS", []);
              }
              let arr = [2, 3, 0, 4, 6, 10, {}];
              if (!arr.includes(res.data.data.skuStatus)) {
                this.$refs.goodsTable.toggleRowSelection(res.data.data, true);
              }
              if (res.data.data.num < res.data.data.minPurchaseNum) {
                this.$refs.goodsTable.toggleRowSelection(res.data.data, false);
              }
              console.log(this.tableData, "this.tableData");

              // item.input = res.data.data.code;
            }
          } else if (res.data.data.code == "" || res.data.data.code == "1") {
            this.$message.closeAll();
            this.$message({
              message: "无法查到商品信息，请确认输入商品编码正确！",
              type: "error",
              showClose: true,
              ccuiCustom: true
            });
            this.$set(this.tableData, index, {});
          }
          // item = res.data.data;
          // console.log(item, index, "-----");
        });
      }
    },
    acceptFile(e) {
      const allowHook = {
        video: ".mp4, .ogv, .ogg, .webm",
        audio: ".wav, .mp3, .ogg, .acc, .webm, .amr",
        file: "doc,.docx,.xlsx,.xls,.pdf",
        excel: ".xlsx,.xls",
        img: ".jpg, .jpeg, .png, .gif"
      };
      if (e) {
        return allowHook[e];
      }
      let srt = null;
      for (const k in allowHook) {
        srt += allowHook[k];
      }
      return srt;
    },
    handleSuccess(res, file, fileList) {
      console.log(this.fileList, "fileList");
      if (res.data.rowPassLimit == 1) {
        this.$message.closeAll();
        this.$message({
          message: res.message,
          type: "error",
          offset: 50,
          customClass: "warning-zc1101",
          showClose: true,
          ccuiCustom: true
        });
      }
      if (this.loadingObj !== undefined) {
        this.loadingObj.close();
        this.loadingObj = undefined;
      }
      if (res.data.list.length) {
        this.tableData = res.data.list[0].list.map(v => {
          if (v.flag == 2) {
            v.ladderPrice = false;
            v.ladderPriceBOS = [];
          }
          return v;
        });
        this.$refs.goodsTable.toggleAllSelection();
        this.tableData.forEach(i => {
          i.input = i.code;
        });
      } else {
        this.$message.closeAll();
        this.$message({
          message: res.message,
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    handleError(res, file, fileList) {
      if (this.loadingObj !== undefined) {
        this.loadingObj.close();
        this.loadingObj = undefined;
      }
      if (res.code == 1) {
        this.$message.closeAll();
        this.$message({
          message: res.message,
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      } else {
        this.$message.closeAll();
        this.$message({
          message: "文件上传失败，请重新上传。",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    handleProgress() {
      this.loadingObj = Loading.service({
        lock: true,
        text: "上传中，请稍等...",
        spinner: "el-icon-loading",
        background: "transparent",
        customClass: "ccui-custom-loading"
      });
    },
    addCart() {
      if (this.selectedItems.length == 0) {
        this.$message.closeAll();
        this.$message({
          message: "请至少选择一件商品",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      } else {
        let list = [];
        let area = "";
        let provinceCode = this.defaultArea[0] ? this.defaultArea[0].code : "";
        let cityCode = this.defaultArea[1] ? this.defaultArea[1].code : "";
        let countyCode = this.defaultArea[2] ? this.defaultArea[2].code : "";
        let streetCode = this.defaultArea[3] ? this.defaultArea[3].code : "";
        if (streetCode) {
          area = `${provinceCode}_${cityCode}_${countyCode}_${streetCode}`;
        } else {
          area = `${provinceCode}_${cityCode}_${countyCode}`;
        }

        this.selectedItems.forEach(i => {
          list.push({
            skuId: i.code,
            num: i.num,
            agentId: "100108",
            area: area
          });
        });
        batchSubAddCart({ list, isShowLoading: true }).then(res => {
          if (res.data.code == 0) {
            this.$message.closeAll();
            if (res.data.data.isFullCart == 1) {
              return this.$confirm(
                `<i class="el-icon-warning-outline"></i>您的购物车商品总数已满，请先清理后继续加入购物车`,
                "温馨提示",
                {
                  distinguishCancelAndClose: true,
                  dangerouslyUseHTMLString: true,
                  showCancelButton: false,
                  confirmButtonText: "去清理",
                  customClass: "ccui-message-box-custom"
                }
              )
                .then(() => {
                  console.log("确定");
                  window.open(this.$addUrlPerFix(process.env.VUE_APP_EMC_URL));
                })
                .catch(() => {
                  console.log("取消");
                });
            }
            this.$message({
              message: "添加购物车成功",
              type: "success",
              showClose: true,
              ccuiCustom: true
            });

            window.location.href = this.$addUrlPerFix(
              process.env.VUE_APP_BASE_URL
            );
          }
        });
      }
    },
    submitOrder(e, n) {
      if (Cookies.get("backCartCartData")) {
        let backCartCartData = JSON.parse(Cookies.get("backCartCartData"));
        Cookies.set("formCartSelect", JSON.stringify(backCartCartData), {
          path: "/",
          domain: "iccec.cn"
        });
      }

      Cookies.remove("backCartCartNum", {
        path: "/",
        domain: "iccec.cn"
      });
      // 之后需要限制一秒内不能提交
      if (e.target.className === "emc-all-submit-order") {
        this.currClick = 1;
      }
      //提交订单
      if (!this.isMonofile) {
        this.submitLastOrder();
      } else {
        this.$message.closeAll();
        this.$message({
          message: "请至少选择一件商品",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    async submitLastOrder() {
      if (this.selectedItems.length === 0) {
        this.$message.closeAll();
        this.$message({
          message: "请至少选择一件商品",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        this.currClick = 0; // 通不过都重置为0
        return false;
      }
      if (this.selectedItems.length > 300) {
        this.$message.closeAll();
        this.$message({
          message: "单次购买商品种类不能超过300种，请重新挑选。",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        this.currClick = 0; // 通不过都重置为0
        return false;
      }
      const skuIds = this.selectedItems.map(v => v.code);
      try {
        // 校验商品变动
        await this.$refs.clearGoods.checkShopStatus(skuIds);
        // 校验商品冻结
        await this.$refs.frozenGoods.checkFrozenSkuInfos(skuIds);
      } catch (err) {
        console.log("err", err);
        this.currClick = 0; // 通不过都重置为0
        return false;
      }
      this.handleSelected(1);
    },

    changeTotal(value, item, index) {
      if (item.maxPurchaseNum && value > item.maxPurchaseNum) {
        this.$set(this.tableData[index], "num", item.maxPurchaseNum);
        value = item.maxPurchaseNum;
        this.$message.closeAll();
        this.$message({
          showClose: true,
          message: `已超过该商品最大购买数量${item.maxPurchaseNum}，不能再添加了！`,
          type: "warning",
          ccuiCustom: true
        });
      } else {
        item.ladderPriceBOS.forEach(i => {
          if (
            item.num >= Number(i.downString) &&
            (item.num <= Number(i.upString) || 10000)
          ) {
            item.salePrice = i.salePrice;
          }
        });
        let arr = [2, 3, 0, 4, 6, 10];
        if (!arr.includes(item.skuStatus)) {
          this.$refs.goodsTable.toggleRowSelection(item, true);
          return (item.total = item.num * item.salePrice);
        }
      }
    },
    handleSelected(rank) {
      let skuIds = [];
      let num = [];
      this.selectedItems.forEach(i => {
        skuIds.push(i.code);
        num.push(i.num);
      });
      let provinceCode = this.defaultArea[0] ? this.defaultArea[0].code : "";
      let cityCode = this.defaultArea[1] ? this.defaultArea[1].code : "";
      let countyCode = this.defaultArea[2] ? this.defaultArea[2].code : "";
      let streetCode = this.defaultArea[3] ? this.defaultArea[3].code : "";
      this.isCheckedState = false;
      window.location.href =
        placeAnOrderUrl +
        `?form=batch&type=placeOrder&skuId=${skuIds}&num=${num}&provinceCode=${provinceCode}&cityCode=${cityCode}&countyCode=${countyCode}&streetCode=${streetCode}&purchaseOrgId=${this.purchaseOrgId}`;
    },
    checkAll(data) {
      //这里是下方全选按钮调用el-table的全选方法
      data
        ? this.$refs.goodsTable.toggleAllSelection()
        : this.$refs.goodsTable.clearSelection();
    },
    // getQuerCartsAll(isloading) {
    //   if (!!window.ActiveXObject || "ActiveXObject" in window) {
    //     // 判断是ie浏览器
    //     this.emcTotalFixDefault = false;
    //     this.emcTotalFix = false;
    //   }
    //   try {
    //     queryCarts({
    //       isShowPageLoading: isloading,
    //       provinceCode: this.defaultArea[0].code,
    //       cityCode: this.defaultArea[1].code,
    //       countyCode: this.defaultArea[2].code,
    //       townCode:
    //         this.defaultArea.length > 3 ? this.defaultArea[3].code : "0",
    //       purchaseOrgId: this.purchaseOrgId
    //     }).then(res => {
    //       if (res.data.code === "0") {
    //         res.data.data = res.data.data.queryEmcS;
    //         this.emcGoodsNum = res.data.data.countCartItem;
    //         this.emcGoodsListData = res.data.data.sons;
    //         if (
    //           this.emcGoodsListData.length === 0 &&
    //           res.data.data.skuList.length === 0
    //         ) {
    //           this.isNoContent = false;
    //           this.flagIsNoContent = true;
    //         } else if (
    //           this.emcGoodsListData.length > 0 &&
    //           res.data.data.skuList.length > 0
    //         ) {
    //           this.isNoContent = true;
    //           this.flagIsNoContent = true;
    //         } else if (
    //           this.emcGoodsListData.length > 0 &&
    //           res.data.data.skuList.length === 0
    //         ) {
    //           this.isNoContent = true;
    //           this.flagIsNoContent = true;
    //         } else if (
    //           this.emcGoodsListData.length === 0 &&
    //           res.data.data.skuList.length > 0
    //         ) {
    //           this.isNoContent = true;
    //           this.flagIsNoContent = true;
    //         } else {
    //           this.isNoContent = true;
    //           this.flagIsNoContent = true;
    //         }
    //         this.selectemcGoodsNum = res.data.data.selectedSkuNum; //已选总商品种类
    //         this.selectemcGoodsTotalPrice = res.data.data.afterPromotionPrice; //总优惠后价格
    //         this.selectemcGoodsTotalDisPrice =
    //           res.data.data.selectSkuPromotionPrice; //总优惠
    //         // 购物车中所有skuis集合
    //         this.checkedEmcGoods.goodsData[
    //           "all"
    //         ] = Emccompute.queryShopAllGoodsCode([], this.emcGoodsListData);
    //         // 失效商品先用别的商品顶一下
    //         this.invalidGoodsListData = res.data.data.skuList;
    //
    //         // =》下面需要用this.checkedEmcGoods.goodsData["all"]
    //         this.emcGoodsListDataFilter(this.emcGoodsListData);
    //       } else {
    //         this.emcGoodsListData = [];
    //         this.invalidGoodsListData = [];
    //       }
    //       this.isCheckedState = true;
    //
    //       this.$nextTick(() => {
    //         this.minHeight = `${document.documentElement.clientHeight -
    //           206 -
    //           456}px`;
    //         this.clientHeight = document.documentElement.clientHeight;
    //         if (document.getElementById("emc-all-total")) {
    //           // console.log(123456);
    //           this.emcTotalOffTop =
    //             document.getElementById("emc-all-total").offsetTop + 238;
    //         }
    //
    //         this.handleScrollx(1);
    //       });
    //     });
    //   } catch (e) {
    //     this.isCheckedState = true;
    //     console.log(e);
    //   }
    // },
    handleScrollx(source) {
      if (document.getElementById("emc-all-total")) {
        this.emcTotalOffTop =
          document.getElementById("emc-all-total").offsetTop + 238;
      }
      this.clientHeight = document.documentElement.clientHeight;
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (document.body.scrollHeight - this.clientHeight > 400) {
        this.emcTotalFixDefault = true;
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          // 判断是ie浏览器
          setTimeout(() => {
            this.emcTotalFixDefault = false;
          }, 200);
          setTimeout(() => {
            this.emcTotalFixDefault = true;
          }, 400);
        }
      }
      if (scrollTop && this.clientHeight + scrollTop <= this.emcTotalOffTop) {
        // this.emcTotalFix = true;
        // setTimeout(() => {
        //   document.getElementsByClassName(
        //     "emc-all-total-fix"
        //   )[0].style.position = "fixed";
        // }, 200);
        this.emcTotalFixDefault = true;
      } else if (
        scrollTop &&
        this.clientHeight + scrollTop > this.emcTotalOffTop
      ) {
        this.emcTotalFixDefault = false;
        // this.emcTotalFix = false;
        // setTimeout(() => {
        //   document.getElementsByClassName(
        //     "emc-all-total-fix"
        //   )[0].style.position = "static";
        // }, 200);
      }
    },
    deletedEmcGoods() {
      this.tableData = this.tableData.filter(
        element => !this.selectedItems.includes(element)
      );
    },
    addGoods() {
      this.tableData.push({});
    },
    toDelete(item) {
      this.tableData.splice(this.tableData.indexOf(item), 1);
    },
    isRed({ row }) {
      const checkIdList = this.selectedItems.map(item => item.code); //拿到原本数组的id
      if (row.code && checkIdList.includes(row.code)) {
        //includes用于搜索筛选关键字 后把数据重新渲染列表
        return {
          height: "90px"
        };
      } else if (row.code) {
        return {
          backgroundColor: "#f0f0f0",
          height: "90px"
        };
      } else {
        return {
          height: "90px"
        };
      }
    },
    handleSelectionChange(val) {
      this.selectedItems = val;
      if (this.selectedItems.length && val.length != this.tableData.length) {
        this.$refs.changeAll1.$el.childNodes[0].classList.add(
          "is-indeterminate"
        );
        this.$refs.changeAll.$el.childNodes[0].classList.add(
          "is-indeterminate"
        );
      } else {
        this.$refs.changeAll1.$el.childNodes[0].classList.remove(
          "is-indeterminate"
        );
        this.$refs.changeAll.$el.childNodes[0].classList.remove(
          "is-indeterminate"
        );
      }
      if (val.length == this.tableData.length) {
        this.changeAll = true;
      } else if (!val.length) {
        this.changeAll = false;
      }
    },
    getAddressOf(cityValue) {
      this.isShow = false;
      let [pcode, cityName] = [[], []];
      cityValue.forEach(i => {
        pcode.push(i.code);
        cityName.push(i.name);
      });
      Cookies.set("IPCodeList", cityValue, { path: "/", domain: "iccec.cn" });
      // 购物车业务
      this.defaultAreaFix = cityValue;
      this.GetQryDefault();
      // this.getQuerCartsAll(true);
    },
    async getInfoTree() {
      qryUnitOrgTree({})
        .then(async res => {
          if (res.data.code === "0") {
            this.unitSelectData = res.data.data.orgData;
            const orgInfoCookie = Cookies.get("orgInfo");
            if (orgInfoCookie && JSON.parse(orgInfoCookie).orgId) {
              const orgInfo = JSON.parse(orgInfoCookie);
              const orgId = orgInfo.orgId;
              this.unitSelectData = res.data.data.orgData.filter(item => {
                return item.orgId === orgId;
              });
              this.purchaseOrgId = orgId;
              this.purchaseUndertakeOrgIdValue = orgInfo.name;
            } else if (
              Cookies.get("backCartCartData") &&
              JSON.parse(Cookies.get("backCartCartData")).deptId &&
              this.backCartCartNum === 1
            ) {
              let dataArr = [JSON.parse(Cookies.get("backCartCartData"))];
              this.purchaseOrgId = dataArr[0].orgId;
              console.log("this.purchaseOrgId");
              this.purchaseUndertakeOrgIdValue = dataArr[0].orgDeptName;
            } else {
              if (res.data.data.orgData.length > 0) {
                console.log("this.purchaseOrgId");
                this.purchaseOrgId = res.data.data.orgData[0].child[0].orgId;
                this.purchaseUndertakeOrgIdValue =
                  res.data.data.orgData[0].child[0].orgDeptName;
              }
            }
          }
          // this.isShow = true;
          if (this.$route.query.type == "inquiry") {
            this.inquiry();
          }
          await this.GetQryDefault();
          if (this.$route.query.type == "inquiry") {
            let {
              provinceCode,
              cityCode,
              countyCode,
              streetCode,
              receiverProvinceName,
              receiverCityName,
              receiverCountyName,
              receiverTown
            } = this.$route.query;
            this.defaultAreaFix = [
              { code: provinceCode, name: receiverProvinceName },
              { code: cityCode, name: receiverCityName },
              { code: countyCode, name: receiverCountyName }
            ];
            console.log(streetCode, receiverTown, "receiverTown");
            if (streetCode != 0) {
              this.defaultAreaFix.push({
                code: streetCode,
                name: receiverTown
              });
            }
            this.defaultArea = Object.assign(this.defaultAreaFix);
          }
          // this.getQuerCartsAll(true);
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
<style>
.warning-zc1101 {
  top: 36vh !important;
}
</style>
<style lang="scss" scoped>
.notAvailable {
  color: red;
}
.emc-all-submit-order {
  margin: 23px 10px 0 0 !important;
  font-weight: 500 !important;
  font-size: 18px !important;
}
.addCart {
  border: 1px #eb273f solid;
  color: #eb273f !important;
  background-color: #fff !important;
}
.emc-title {
  border-bottom: 2px solid #ff142f;
}
.flex {
  display: flex;
  float: right;
  padding-right: 21px;
}
.orderHelp {
  margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  .orderHelp_step {
    cursor: pointer;
    width: 150px;
    height: 120px;
    display: grid;
    align-content: center;
    justify-items: center;
    border: 1px dashed #ff142f;
    //display: grid;
    //justify-content: center;
    &:active {
      color: #ff142f;
    }
  }
}
.dottedLine {
  width: 241px;
  height: 1px;
  border-bottom: 1px dashed #ff142f;
}
.promptHelp {
  margin-bottom: 30px;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999999;
  font-size: 14px;
  //width: 600px;
}
/deep/.icon-ccui-next {
  color: #ff142f;
}
/deep/.is-leaf {
  background: #eeeeee;
  //border-left: 2px #fff solid;
  color: #9b9b9b;
  font-size: 13px;
  &:first-child {
    border-left: none !important;
  }
}
/deep/.el-checkbox__inner {
  //background-color: #fff !important;
}
/deep/.el-table th {
  padding: 10px 0;
}
.solidLine {
  border-bottom: 1px solid #f1f1f1;
  margin-bottom: 15px;
}
.goods-list-commodity-table-body-center {
  width: 56px;
  height: 56px;
}
.clearfix {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.goods-list-commodity-table-body-right {
  //white-space: normal;
  //word-break: break-all;
  //overflow: hidden;
  //text-overflow: ellipsis;
  //display: -webkit-box;
  //-webkit-line-clamp: 2;
  //-webkit-box-orient: vertical;
  margin-left: 10px;
  font-size: 12px;
}
.goods-list-commodity-table-body-right-item-title {
  white-space: normal;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.goodsCoding /deep/.el-input__inner {
  border: 1px solid #fff !important;
  font-size: 13px;
  height: 35px;
  width: 100px;
  border-radius: 0 !important;
  background-color: #f1f1f1;
}

/deep/.el-table td {
  padding-top: 10px !important;
  vertical-align: top !important;
}
/deep/.el-table td:last-child {
  text-align: center;
}
/deep/.el-table td,
.el-table th {
  padding: 0;
}
/deep/.el-table--border td {
  border-right: 0;
}
/deep/.el-input-number {
  width: 84px;
  height: 28px;
  line-height: 25px;
  position: relative;
  display: inline-block;
  .el-input-number__increase {
    width: 27px;
    top: 2px;
    height: 25px;
    background: #fff;
    border-left: 1px solid #f1f1f1;
    right: 1px;
    border-radius: 0 4px 4px 0;
  }
  .el-input-number__decrease {
    width: 25px;
    top: 1px;
    height: 26px;
    background: #fff;
    left: 1px;
    border-radius: 4px 0 0 4px;
    border-right: 1px solid #f1f1f1;
  }
  .el-input__inner {
    height: 28px;
    padding: 0;
  }
}
.addGoods {
  //cursor: pointer;
  display: flex;
  background-color: #f8f8f8;
  height: 70px;
  font-size: 14px;
  /* text-align: center; */
  color: #eb273f;
  justify-content: center;
  align-items: center;
}
.emc-all-total-l {
  line-height: normal;
  position: static;
  padding-top: 0 !important;
  margin: 25px 0;
}
.emc-checkbox {
  margin-left: 10px;
}
.tab-text {
  font-size: 12px;
}
/deep/.el-upload-list {
  display: none;
}
/deep/.el-loading-mask {
  opacity: 0.8;
}
/deep/.is-leaf {
  font-weight: 400;
  font-size: 13px !important;
}
.clickAdd {
  cursor: pointer;
}
.goods-price-select {
  margin-right: 70px;
  cursor: pointer;
  margin-top: 3px;
  height: 24px;
  span.promotion {
    width: 53px;
  }
  span.set-price {
    position: absolute;
    width: 70px;
  }
  span {
    display: inline-block;
    position: relative;
    height: 22px;
    .goods-price-select-title {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0 22px 0 5px;
      display: inline-block;
      min-width: 41px;
      height: 20px;
      line-height: 20px;
      border: 1px solid #ff0037;
      color: #ff0037;
      font-size: 12px;
    }
    i {
      position: absolute;
      right: 5px;
      top: 4px;
      width: 10px;
      height: 8px;
      color: #ff142f;
    }
    .goods-price-select-box {
      display: none;
      position: absolute;
      top: 18px;
      left: 5.5px;
      width: 230px;
      border: 1px solid #ff0037;
      background: #ffffff;
      z-index: 2;
      ul {
        padding: 10px;
      }
      li tr td {
        list-style: none;
        font-size: 13px;
        color: #4a4a4a;
        line-height: 12px;
        //padding-bottom: 10px;
      }
      li tr.active td {
        color: #ff142f;
      }
    }
  }
  :hover {
    i {
      top: 8px;
      transform: rotate(180deg);
    }
    .goods-price-select-title {
      z-index: 3;
      background: #fff;
      border-bottom: none;
    }
    .goods-price-select-box {
      display: block;
      .active {
        color: #ff142f;
      }
    }
  }
}
/deep/.el-table {
  overflow: inherit !important;
}
/deep/.el-table__body-wrapper {
  overflow: inherit !important;
}
</style>
